import { useRef, useState } from 'react';
import { useSnackbar } from 'fronton-react';
import { v4 as uuidv4 } from 'uuid';
import { geStatusConfig } from '../utils';
import { StatusType } from '../types';

type StatusClickHandler = (statusType: StatusType) => void;

export const useComparisonListStatus = () => {
  const [id, setId] = useState(uuidv4());
  const { state: items, removeSnack, addSnack } = useSnackbar();
  const clickHandlerRef = useRef<StatusClickHandler>();
  const config = geStatusConfig();
  return {
    items,
    showStatus: (statusType: StatusType) => {
      const newId = uuidv4();
      setId(newId);
      const data = config[statusType];
      if (data) {
        addSnack({
          ...data,
          id: newId,
          onClick: () => {
            if (clickHandlerRef.current) {
              clickHandlerRef.current(statusType);
            }
          },
          onClose: () => removeSnack(newId),
        });
      }
    },
    hideStatus: () => removeSnack(id),
    setClickHandler: (handler: StatusClickHandler) => {
      clickHandlerRef.current = handler;
    },
  };
};
